import React, { useState } from 'react';

function ScenarioPanel({ 
  scenarios, 
  activeScenario, 
  onSelectScenario, 
  onCreateScenario, 
  onDeleteScenario,
  onCompareScenarios
}) {
  const [selectedForComparison, setSelectedForComparison] = useState([]);
  
  // Toggle a scenario for comparison
  const toggleScenarioForComparison = (scenarioId) => {
    setSelectedForComparison(prev => 
      prev.includes(scenarioId)
        ? prev.filter(id => id !== scenarioId)
        : [...prev, scenarioId]
    );
  };
  
  return (
    <div className="scenario-panel">
      <div className="panel-header">
        <h2>Scenarios</h2>
        <button onClick={onCreateScenario} className="create-btn">New Scenario</button>
      </div>
      
      {scenarios.length === 0 ? (
        <div className="empty-scenarios">
          <p>No scenarios created yet</p>
        </div>
      ) : (
        <>
          <ul className="scenario-list">
            {scenarios.map(scenario => (
              <li 
                key={scenario.id} 
                className={`scenario-item ${activeScenario === scenario.id ? 'active' : ''}`}
              >
                <div className="scenario-item-content">
                  <input
                    type="checkbox"
                    checked={selectedForComparison.includes(scenario.id)}
                    onChange={() => toggleScenarioForComparison(scenario.id)}
                    className="compare-checkbox"
                  />
                  <div
                    className="scenario-name"
                    onClick={() => onSelectScenario(scenario.id)}
                  >
                    {scenario.name}
                  </div>
                  <button 
                    onClick={() => onDeleteScenario(scenario.id)}
                    className="delete-btn"
                    aria-label="Delete scenario"
                  >
                    ×
                  </button>
                </div>
                
                <div className="scenario-details">
                  {scenario.audienceName && <div>Audience: {scenario.audienceName}</div>}
                  <div>Budget: ${scenario.budget.toLocaleString()}</div>
                  <div>Channels: {scenario.channels.length}</div>
                  {scenario.results && (
                    <div className="scenario-results">
                      <div>Reach: {scenario.results.netReach?.toFixed(2)}%</div>
                      <div>Frequency: {scenario.results.netFrequency?.toFixed(2)}x</div>
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
          
          {selectedForComparison.length >= 2 && (
            <button 
              onClick={() => onCompareScenarios(selectedForComparison)}
              className="compare-btn"
            >
              Compare Selected ({selectedForComparison.length})
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default ScenarioPanel;